// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialSecurityFreeDetails_container__3vey_","title":"SocialSecurityFreeDetails_title__1goRv","content":"SocialSecurityFreeDetails_content__1ncEJ"};